import Vue from 'vue'
// 引入全局 element-ui
import elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import QRcode from 'vue-qriously'

import 'leaflet/dist/leaflet.css'
import * as L from 'leaflet'
import './Semicircle.js'


Vue.$L = Vue.prototype.$L = L
Vue.prototype.$bus = new Vue();
// require styles
import 'swiper/swiper-bundle.min.css'

Vue.use(elementui)
Vue.use(QRcode)

// 引入全局样式
import '@/assets/scss/base.scss'
import '@/assets/scss/element-theme.scss'
import '@/components/icons'
